import type { NostrEvent } from '@nostrify/nostrify';

export interface QuizQuestion {
  question: string;
  options: string[];
  correctIndex: number;
}

export interface Article {
  id: string;
  pubkey: string;
  slug: string;
  title: string;
  summary: string;
  content: string;
  image?: string;
  category: string;
  publishedAt: number;
  createdAt: number;
  quiz?: QuizQuestion[];
  event: NostrEvent;
}

export interface ArticleFormData {
  title: string;
  summary: string;
  content: string;
  image?: string;
  category: string;
  quiz: QuizQuestion[];
}

export function parseArticle(event: NostrEvent): Article | null {
  const dTag = event.tags.find(([name]) => name === 'd')?.[1];
  const title = event.tags.find(([name]) => name === 'title')?.[1];
  const summary = event.tags.find(([name]) => name === 'summary')?.[1];
  const image = event.tags.find(([name]) => name === 'image')?.[1];
  const publishedAt = event.tags.find(([name]) => name === 'published_at')?.[1];
  
  // Get category from t tags (excluding site tag)
  const tTags = event.tags.filter(([name]) => name === 't').map(([, value]) => value);
  const category = tTags.find((t) => t !== 'wtfisbitcoin') || 'grundlagen';

  if (!dTag || !title) {
    return null;
  }

  // Parse quiz from content if present
  let content = event.content;
  let quiz: QuizQuestion[] | undefined;

  // Check for quiz JSON at the end of content
  const quizMatch = content.match(/\n\n<!-- QUIZ_START -->\n([\s\S]*?)\n<!-- QUIZ_END -->$/);
  if (quizMatch) {
    try {
      quiz = JSON.parse(quizMatch[1]);
      content = content.replace(quizMatch[0], '');
    } catch {
      // Invalid quiz JSON, ignore
    }
  }

  return {
    id: event.id,
    pubkey: event.pubkey,
    slug: dTag,
    title,
    summary: summary || '',
    content,
    image,
    category,
    publishedAt: publishedAt ? parseInt(publishedAt, 10) : event.created_at,
    createdAt: event.created_at,
    quiz,
    event,
  };
}

export function formatArticleContent(
  content: string,
  quiz?: QuizQuestion[]
): string {
  if (!quiz || quiz.length === 0) {
    return content;
  }

  return `${content}\n\n<!-- QUIZ_START -->\n${JSON.stringify(quiz)}\n<!-- QUIZ_END -->`;
}
